module.exports = __webpack_public_path__ + "img/arrowLeft.dc6b357d.svg";